import React, { useEffect, useState } from 'react';
import style from '../../css/inquiry.module.css'
import { postAsync } from '../../utils/httpClient';
import { INQUIRY_CREATE, INQUIRY_REGION } from '../../constant/identifier';
import { formatBirthDate, formatPhoneNumber } from '../../utils/utils';
import { cityName } from '../../utils/data';
import { CustomAlretDialog } from '../Components/Dialog';


const RiderInquiry = () => {

  // 성함
  const [name, setName] = useState('')
  // 연락처
  const [phone, setPhone] = useState('')
  // 생년월일
  const [birth, setBirth] = useState('')
  // 지역
  const [region, setRegion] = useState('')
  // 시군구명 목록
  const [districts, setDistricts] = useState([]);
  // 근무경험
  const [workExp, setWorkExp] = useState('')
  // 바이크 보유여부
  const [havebike, setHaveBike] = useState('')
  // 내용
  const [contents, setContents] = useState('')

  // 지역 두번째옵션 값
  const [selectedDistrict, setSelectedDistrict] = useState('');

  // 개인정보 처리방침 동의
  const [isAgreed, setIsAgreed] = useState(false);

  const hasbike = ['유', '무']

  // 다이어로그 메세지
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  // Dialog 열,닫 기
  const showDialog = (message) => {
    setDialogMessage(message);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };


  useEffect(() => {
    if (region && region !== '') {
      postAsync(INQUIRY_REGION, { "siDoName": region })
        .then((res) => {
          const districtData = res.data.map(item => item["시군구명"]);
          setDistricts(districtData);
          setSelectedDistrict('');
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    else {
      setDistricts([])
      setSelectedDistrict('');
    }
  }, [region])

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
  };
  const handlePhoneChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };


  const InquiryBtn = () => {

    if (!name) {
      showDialog("성함 입력은 필수값입니다");
      return;
    }
    if (!phone) {
      showDialog("연락처 입력은 필수값입니다");
      return;
    }
    if (!birth) {
      showDialog("생년월일 입력은 필수값입니다");
      return;
    }
    if (!region) {
      showDialog("희망지역을 선택해야 합니다.");
      return;
    }

    if (!selectedDistrict) {
      showDialog("시군구명도 선택해야 합니다.");
      return;
    }
    if (!workExp) {
      showDialog("근무경험 입력은 필수값입니다");
      return;
    }
    if (!havebike) {
      showDialog("바이크 보유여부는 필수값입니다");
      return;
    }

    if (!contents || contents.trim() === '') {
      showDialog("내용 입력은 필수값입니다");
      return;
    }

    if (!isAgreed) {
      showDialog("개인정보 보호방침에 동의해야 합니다.");
      return;
    }
    postAsync(
      INQUIRY_CREATE, {
      inquiry: {
        "category": 2,
        "user_name": name,
        "user_phone": phone,
        "birthday": birth,
        "region": `${region} ${selectedDistrict}`,
        "workingExp": workExp,
        "bike": havebike === '유' ? true : false,
        "contents": contents,
        "isPersonal": isAgreed
      }
    }).then((res) => {
      if (res.message === "success") {
        showDialog("신청이 완료되었습니다.");
        setName('')
        setPhone('')
        setBirth('')
        setRegion('')
        setDistricts([])
        setWorkExp('')
        setHaveBike('')
        setContents('')
        setIsAgreed(false)
      } else {
        showDialog(res.message);
      }
    })
      .catch((error) => {
        console.error("Error:", error);
      });
  }


  return (
    <div>
      <div id={style.sub_con_warp} >
        <div className={style.sub11_con01}>
          <div className={style.sub11_con01_left} >
            <div className={style.sub11_text01} >
              성함 <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <input
                className={style.sub11_input01}
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="이름을 입력해주세요."
                autoComplete="off"
                maxLength={20}
              />
            </div>
          </div>
          <div className={style.sub11_con01_right} >
            <div className={style.sub11_text01}>
              연락처 <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <input
                className={style.sub11_input01}
                name="name"
                value={phone}
                onChange={handlePhoneChange}
                placeholder="예 : 010-0000-0000"
                autoComplete="off"
                maxLength={14}
              />
            </div>
          </div>
        </div>

        <div className={style.sub11_con01} >
          <div className={style.sub11_con01_left} >
            <div className={style.sub11_text01} >
              생년월일 <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <input
                className={style.sub11_input01}
                name="name"
                value={birth}
                onChange={(e) => setBirth(formatBirthDate(e.target.value))}
                placeholder="예 : 1987.02.03"
                autoComplete="off"
              />
            </div>
          </div>
          <div className={style.sub11_con01_right} >
            <div className={style.sub11_text01}>
              지역  <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <select
                className={style.sub11_input02}
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <option value="" selected="selected">도(시) 선택 </option>
                {cityName.map((city, index) => (
                  <option key={index} value={city}>{city}</option>
                ))}
              </select>
              &nbsp;&nbsp;
              <select
                className={style.sub11_input02}
                value={selectedDistrict}
                onChange={handleDistrictChange}
              >
                <option value="" selected="selected">시구군 선택 </option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className={style.sub11_con01} >
          <div className={style.sub11_con01_left} >
            <div className={style.sub11_text01} >
              근무경험 <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <input
                className={style.sub11_input01}
                name="name"
                value={workExp}
                onChange={(e) => setWorkExp(e.target.value)}
                placeholder="경험 여부를 말씀해주세요."
                autoComplete="off"
                maxLength={100}
              />
            </div>
          </div>
          <div className={style.sub11_con01_right} >
            <div className={style.sub11_text01} >
              바이크 보유여부 <span style={{ color: "#ff0000" }}>*</span>
            </div>
            <div>
              <select
                className={style.sub11_input02}
                name="havebike"
                value={havebike}
                onChange={(e) => setHaveBike(e.target.value)}
              >
                <option value="">유 / 무</option>
                {hasbike.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className={style.sub11_con02} >
          <div className={style.sub11_text01} >
            내용 <span style={{ color: "#ff0000" }}>*</span>
          </div>
          <textarea
            className={style.custom_textarea}
            value={contents}
            onChange={(e) => setContents(e.target.value)}
            maxLength={400}
          />
        </div>

        <div className={style.sub11_con03}>
          <div className={style.sub11_con03_left} >
            <input
              className={style.sub11_input03}
              type="checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              value="동의함"
            />
          </div>
          <div className={style.sub11_con03_right}>
            <p className={style.sub11_text02} > 개인정보 보호방침에 동의합니다.</p>
          </div>
        </div>

        <div className={style.sub11_con04}>
          <input
            className={style.sub11_input04}
            type='button'
            value='문의하기'
            onClick={InquiryBtn}
          />
        </div>
        <CustomAlretDialog
          open={dialogOpen}
          message={dialogMessage}
          close={handleDialogClose}
        />
      </div>
    </div>
  );
}

export default RiderInquiry;
